import { ListType, ObjectType, Property, TypeKind } from '../types.js';
import { ListSourcedValue, Option, SourcedValue } from '../option.js';
export class OneLevelListWalker {
    constructor(schema, propertyValue, stopProcessingCallback = null) {
        this.stopProcessingCallback = stopProcessingCallback;
        this.properties = [];
        this.nextIndex = 0;
        let fromSourcedValue = (propertyValue.property.opts.needSource && (propertyValue.value instanceof ListSourcedValue || propertyValue.value.value)) ? propertyValue.value.value : propertyValue.value;
        if (!(Array.isArray(fromSourcedValue))) {
            throw new Error(`Model '${JSON.stringify(fromSourcedValue)}' should be a list`);
        }
        this.propertyValue = propertyValue;
        this.schema = schema;
        let type = this.schema.getType(propertyValue.property.type);
        if (!(type instanceof ListType)) {
            throw new Error(`Type '${propertyValue.property.type}' should be an list type`);
        }
        this.type = type;
        this.itemType = this.type.elementType;
        this.items = fromSourcedValue.slice();
    }
    next() {
        let currentItem = this.items[this.nextIndex];
        if (!currentItem) {
            return undefined;
        }
        const property = new Property(this.nextIndex.toString(), this.itemType);
        this.nextIndex++;
        return { property: property, value: currentItem, parent: { parent: this.propertyValue.parent, property: this.propertyValue.property, value: this.items } };
    }
}
export class OneLevelModelWalker {
    constructor(schema, propertyValue, stopProcessingCallback = null) {
        this.stopProcessingCallback = stopProcessingCallback;
        this.properties = [];
        if (!(propertyValue.value instanceof Object)) {
            throw new Error(`Model '${propertyValue.value}' should be an object`);
        }
        this.propertyValue = propertyValue;
        this.schema = schema;
        let type = this.schema.getType(propertyValue.property.type);
        if (!(type instanceof ObjectType)) {
            throw new Error(`Type '${propertyValue.property.type}' should be an object type`);
        }
        this.type = type;
        for (const property of type.properties) {
            this.properties.push(property.name);
        }
        this.properties.sort().reverse();
    }
    next() {
        let currentPropertyName = this.properties.pop();
        if (!currentPropertyName) {
            return undefined;
        }
        let property = this.type.getProperty(currentPropertyName);
        if (!property) {
            throw new Error(`Property '${currentPropertyName}' not exist in type ${this.type.getTypeReference()}`);
        }
        const value = getPropertyValue(currentPropertyName, this.propertyValue.value);
        return { property: property, value: value, parent: this.propertyValue };
    }
}
const getPropertyValue = (name, value) => {
    if (value instanceof Option) {
        return value.model[name];
    }
    else if (value instanceof SourcedValue) {
        return getPropertyValue(name, value.value);
    }
    else {
        return value[name];
    }
};
export class DeepModelWalker {
    constructor(schema, model, typeRef, stopProcessingCallback = null) {
        this.stopProcessingCallback = stopProcessingCallback;
        this.walkers = [];
        const rootWalker = Array.isArray(model) ? OneLevelListWalker : OneLevelModelWalker;
        this.walkers.push(new rootWalker(schema, { parent: undefined, property: new Property('$', typeRef), value: model }, this.stopProcessingCallback));
        this.model = model;
        this.schema = schema;
        let type = this.schema.getType(typeRef);
        this.type = type;
    }
    next() {
        if (this.walkers.length == 0) {
            return undefined;
        }
        const walker = _peek(this.walkers);
        let propertyValue = walker.next();
        if (propertyValue) {
            if (propertyValue.value) {
                let type = this.schema.getType(propertyValue.property.type);
                let fromSourcedValue = propertyValue.value;
                let goFurther = true;
                if (this.stopProcessingCallback) {
                    goFurther = this.stopProcessingCallback(propertyValue);
                }
                if (goFurther) {
                    if (type.kind == TypeKind.Object && fromSourcedValue instanceof Object) {
                        this.walkers.push(new OneLevelModelWalker(this.schema, {
                            value: getPropertyValue(propertyValue.property.name, propertyValue.parent.value),
                            property: propertyValue.property,
                            parent: propertyValue.parent
                        }, this.stopProcessingCallback));
                    }
                    else if (type.kind == TypeKind.List) {
                        this.walkers.push(new OneLevelListWalker(this.schema, {
                            value: propertyValue.value,
                            property: propertyValue.property,
                            parent: propertyValue.parent
                        }, this.stopProcessingCallback));
                    }
                }
                return propertyValue;
            }
            else {
                return propertyValue;
            }
        }
        else {
            this.walkers.pop();
            return this.next();
        }
    }
}
function _peek(arr) {
    return arr[arr.length - 1];
}
//# sourceMappingURL=ModelWalker.js.map